import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=41db58a4&scoped=true&"
var script = {}
import style0 from "./Title.vue?vue&type=style&index=0&id=41db58a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41db58a4",
  null
  
)

export default component.exports